var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBookmarkEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.304 2.70059C15.304 2.40222 15.1879 2.11615 14.9815 1.90518C14.7751 1.6942 14.4952 1.57559 14.2032 1.57559H5.3968C5.10485 1.57559 4.82494 1.6942 4.6185 1.90518C4.41206 2.11615 4.296 2.40222 4.296 2.70059V15.7884L9.41644 12.0513L9.50588 11.9959C9.72175 11.8861 9.98277 11.9048 10.1836 12.0513L15.304 15.7884V2.70059ZM16.625 17.1006C16.625 17.3534 16.4863 17.5852 16.2663 17.7009C16.0465 17.8163 15.7821 17.7966 15.5809 17.6499L9.8 13.4294L4.01908 17.6499C3.81788 17.7966 3.55349 17.8163 3.33366 17.7009C3.11367 17.5852 2.97504 17.3534 2.97504 17.1006V2.70059C2.97504 2.04418 3.23037 1.41484 3.68454 0.950684C4.13871 0.486531 4.75451 0.225586 5.3968 0.225586H14.2032C14.8455 0.225586 15.4613 0.486531 15.9155 0.950684C16.3696 1.41484 16.625 2.04417 16.625 2.70059V17.1006Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkEmpty);
export default __webpack_public_path__ + "static/media/icon-bookmark-empty.043fb2c9446729962acdd38106987294.svg";
export { ForwardRef as ReactComponent };